import { useState, useEffect } from "react";
import CustomerDrawer from "../components/CustomerComponent/CustomerDrawer";
import Devices from "../components/Devices";
import { customerContext } from "../context/contexts";
import { boxStyle, searchStyle, headerStyle } from "../style/style";
import { Box, Card } from "@mui/material";
import DeviceDetail from "../components/DeviceDetail";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import Customersetting from "../components/CustomerComponent/Customersetting";
import CustomerHubs from "../components/CustomerComponent/CustomerHubs";
import CustomerBillingDetail from "../components/CustomerComponent/CustomerBillingDetail";
import { getobj } from "../apicall/apicall";
import CustomerReplacedDevice from "../components/CustomerComponent/CustomerReplacedDevice";

export default function CustomerPage() {
  const [manage, setmanage] = useState({
    Devices: true,
    deviceDetail: false,
    Billing: false,
    Settings: false,
    refresh: false,
    Hubs: false,
    replaceDevice: false,
  });
  const [id, setid] = useState();
  const [hub_id, sethub_id] = useState("");
  const [search, setsearch] = useState(
    manage.Devices
      ? sessionStorage.getItem("search_devices")
        ? sessionStorage.getItem("search_devices")
        : ""
      : "",
  );
  const [enter, setenter] = useState(
    manage.Devices
      ? sessionStorage.getItem("search_devices")
        ? true
        : false
      : false,
  );
  const [customerDetails, setCustomerDetails] = useState({});

  const history = useNavigate();

  useEffect(() => {
    if (
      sessionStorage.getItem("token") === "" ||
      !sessionStorage.getItem("token")
    ) {
      alert("Please log in to view this page!");
      history({ pathname: "/" });
    }

    const customer_id = sessionStorage.getItem("customer_id");
    const url =
      process.env.REACT_APP_ZEWA_URL + "user/get-customer/" + customer_id + "/";
    const res = getobj(url);
    res.then(function (r) {
      setCustomerDetails(r.data);
      // console.log(r);
    });
  }, [history]);

  const customer_id = sessionStorage.getItem("customer_id");
  const handleSubmit = (e) => {
    e.preventDefault();
    sessionStorage.setItem("search_devices", search);

    setenter(true);
  };
  const handleSearch = (e) => {
    setenter(false);
    setsearch(e.target.value);
    if (e.target.value === "") {
      setenter(true);
      sessionStorage.removeItem("search_devices");
    }
  };
  const form2 = (
    <form style={searchStyle} onSubmit={handleSubmit}>
      <FormControl variant="standard" sx={searchStyle}>
        <InputLabel htmlFor="input-with-icon-adornment">Search ...</InputLabel>
        <Input
          id="input-with-icon-adornment"
          startAdornment={
            <InputAdornment position="start">
              <SearchSharpIcon color="primary" />
            </InputAdornment>
          }
          value={search}
          onChange={handleSearch}
        />
      </FormControl>
    </form>
  );

  return (
    <div>
      {localStorage.getItem("role") === "CUSTOMER" ? (
        <customerContext.Provider
          value={{ manage: manage, setmanage: setmanage, id: id, setid: setid }}
        >
          <Box>
            <Box>
              <Grid container spacing={2}>
                <Grid item xs={2}>
                  <CustomerDrawer
                    search={search}
                    setsearch={setsearch}
                    setenter={setenter}
                    logo={customerDetails.logo}
                  />
                </Grid>
                <Grid item xs={10}>
                  {manage.Devices && (
                    <Box sx={boxStyle}>
                      <Card sx={headerStyle}>
                        Device List
                        {form2}
                      </Card>
                      <span style={{ margin: "0.625rem" }}></span>

                      <Card>
                        <Devices
                          id={customer_id}
                          search={enter ? search : ""}
                        />
                      </Card>
                    </Box>
                  )}
                  {manage.Billing === true && (
                    <Box x={boxStyle}>
                      <Card sx={boxStyle}>
                        <Card sx={headerStyle}>Billing Info</Card>
                      </Card>

                      <Card sx={boxStyle}>
                        <CustomerBillingDetail
                          id={customer_id}
                          customerDetails={customerDetails}
                        />
                      </Card>
                    </Box>
                  )}
                  {manage.Settings === true && (
                    <Box sx={boxStyle}>
                      <Card sx={headerStyle}>Setting{form2}</Card>
                      <span style={{ margin: "0.625rem" }}></span>
                      <Customersetting
                        customer_id={customer_id}
                        search={enter ? search : ""}
                      />
                    </Box>
                  )}
                  {manage.replaceDevice === true && (
                    <Box sx={boxStyle}>
                      <Card sx={headerStyle}>Replace Device List{form2}</Card>
                      <span style={{ margin: "0.625rem" }}></span>
                      <CustomerReplacedDevice
                        customer_id={customer_id}
                        search={enter ? search : ""}
                      />
                    </Box>
                  )}
                  <Box> {manage.deviceDetail === true && <DeviceDetail />}</Box>
                  {manage.Hubs === true && (
                    <Box sx={boxStyle}>
                      <Card sx={headerStyle}>
                        {hub_id === "" ? "Hubs" : hub_id} {form2}
                      </Card>
                      <Card sx={{ marginTop: "0.625rem" }}>
                        <Box sx={{ margin: "1.25rem" }}>
                          <CustomerHubs
                            search={enter ? search : ""}
                            id={customer_id}
                            hubsid={hub_id}
                            sethub_id={sethub_id}
                          />
                        </Box>
                      </Card>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Box>
        </customerContext.Provider>
      ) : (
        alert("You do not have permission to access this resource.")
      )}
    </div>
  );
}
